import { useEffect, useState, useRef, useContext } from "react";
import { ConfigContext } from "../util/ConfigContext";
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
import API_URL from "../config/apiConfig";
import { apiGet } from "../util/axiosUtil";

const Zoom = () => {
  const [participants, setParticipants] = useState([]);
  const [chatMessages, setChatMessages] = useState([]);
  const zoomClientRef = useRef(null);
  const isJoinedRef = useRef(false);
  const { jwt } = useContext(ConfigContext);
  const SDK_KEY = "LjbfalN3RTqzJyrdC0BZQ";
  const meetingNumber = "2707885874";
  const userName = jwt.un;
  const passWord = "634846";

  const fetchParticipants = async () => {
    const client = zoomClientRef.current;
    if (client?.isHost()) {
      try {
        const allUsers = await client.getAttendeeslist();
        setParticipants(allUsers || []);
      } catch (err) {
        setParticipants([]);
      }
    }
  };

  const updateSingleParticipant = (user) => {
    setParticipants((prev) =>
      prev.map((p) => (p.userId === user.userId ? { ...p, ...user } : p))
    );
  };

  const setupListeners = (client) => {
    client.on("user-added", () => {
      // console.log("User added");
      fetchParticipants();
    });

    client.on("user-removed", () => {
      // console.log("User removed");
      fetchParticipants();
    });

    client.on("user-updated", (userData) => {
      // console.log("User updated data:", userData);
      if (Array.isArray(userData)) {
        userData.forEach((user) => {
          if (user?.userId) {
            updateSingleParticipant(user);
          }
        });
      }
    });
    client.on("broadcast-message", (chatMessage) => {
      // console.log(
      //   `Chat from ${chatMessage.senderName}: ${chatMessage.message}`
      // );
      // setChatMessages((prev) => [...prev, chatMessage]);
    });
    // client.on("chat-message", (chatMessage) => {
    //   console.log(
    //     `Chat from ${chatMessage.senderName}: ${chatMessage.message}`
    //   );
    //   setChatMessages((prev) => [...prev, chatMessage]);
    // });
  };

  const joinMeeting = async () => {
    if (!zoomClientRef.current) {
      zoomClientRef.current = ZoomMtgEmbedded.createClient();
    }

    const client = zoomClientRef.current;
    const meetingSDKElement = document.getElementById("zoom-root");

    try {
      const response = await apiGet(`{API_URL}/api/zooms/get-zoom-token`);
      const { signature, zak } = response.data;

      await client.init({
        zoomAppRoot: meetingSDKElement,
        language: "en-US",
        customize: {
          chat: false,
          share: false,
          toolbar: false,
        },
        patchJsMedia: true,
        leaveOnPageUnload: true,
      });

      await client.join({
        sdkKey: SDK_KEY,
        signature,
        meetingNumber,
        password: passWord,
        userName,
        ...(zak && { zak }),
      });

      isJoinedRef.current = true;
      setupListeners(client);
      fetchParticipants();
    } catch (error) {
      console.error("Error joining meeting:", error);
    }
  };

  // const sendChatMessage = async (msg, userId) => {
  //   console.log("Sending chat message:", msg, "to user:", userId);
  //   try {
  //     const result = await zoomClientRef.current?.sendChat(msg, userId);
  //     if (result instanceof Error) {
  //       console.error("Zoom Chat Error:", result);
  //     } else {
  //       console.log("Chat message sent:", result);
  //     }
  //   } catch (err) {
  //     console.error("Chat promise rejected:", err);
  //   }
  // };

  const sendChatMessage = async (msg) => {
    // console.log("Sending chat message:", msg, "to user:", userId);
    try {
      const result = await zoomClientRef.current?.broadcast(msg);
      if (result instanceof Error) {
        console.error("Zoom Chat Error:", result);
      } else {
        console.log("Chat message sent:", result);
      }
    } catch (err) {
      console.error("Chat promise rejected:", err);
    }
  };

  const muteUser = async (userId) => {
    const client = zoomClientRef.current;
    console.log(client, "Client for Mute: ", client);
    const user = participants.find((p) => p.userId === userId);
    console.log("User for Mute: ", user);

    if (!client || !user) {
      console.warn("Client or user not found.");
      return;
    }

    if (!client.isHost()) {
      console.warn("You must be host to mute users.");
      return;
    }

    const audioStatus = user.audioStatus || user.audio;
    console.log(`${user.displayName} audio status:`, audioStatus);

    if (
      !audioStatus ||
      audioStatus === "unavailable" ||
      audioStatus === "not joined"
    ) {
      console.warn(`${user.displayName} has not joined audio.`);
      return;
    }

    try {
      console.log("Trying to mute of userId: ", userId);
      await client.mute(userId);
      console.log(`Muted user: ${userId}`);
    } catch (err) {
      console.error("Mute error:", err);
    }
  };

  const unmuteUser = () => sendChatMessage("Unmute me");
  const muteAll = () => zoomClientRef.current?.muteAll();
  const unmuteAll = () => zoomClientRef.current?.unmuteAll();
  const logoutUser = (userId) => zoomClientRef.current?.expel(userId);
  const logoutAll = () => participants.forEach((p) => logoutUser(p.userId));

  useEffect(() => {
    return () => {
      if (zoomClientRef.current) {
        zoomClientRef.current.off("user-added");
        zoomClientRef.current.off("user-removed");
        zoomClientRef.current.off("user-updated");
        zoomClientRef.current.off("chat-message");
      }
    };
  }, []);

  return (
    <div className="p-6  min-h-screen">
      <div className="flex flex-col justify-end md:flex-row md:items-center gap-4 mb-6">
        <button onClick={joinMeeting} className="btn-primary">
          Join Meeting
        </button>
        <button onClick={muteAll} className="btn-secondary">
          Mute All
        </button>
        <button onClick={unmuteAll} className="btn-secondary">
          Unmute All
        </button>
        <button onClick={logoutAll} className="btn-danger">
          Logout All
        </button>
      </div>

      <div id="zoom-root" className="mb-8"></div>

      <h3 className="text-2xl font-semibold mb-4 text-gray-800">
        Participants
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {participants.map((p) => (
          <div
            key={p.userId}
            className="bg-white rounded-xl shadow-md p-5 flex flex-col justify-between"
          >
            <div className="mb-4">
              <div className="text-lg font-medium text-gray-800">
                {p.displayName || p.userId || "Unknown"}
              </div>
              <div
                className={`text-sm font-medium ${
                  p.muted ? "text-red-500" : "text-green-600"
                }`}
              >
                {p.muted ? "Muted" : "Unmuted"}
              </div>
            </div>
            <div className="flex gap-2 mt-auto">
              <button
                onClick={() => muteUser(p.userId)}
                className="btn-sm-secondary"
              >
                Mute
              </button>
              <button
                onClick={() => unmuteUser(p.userId)}
                className="btn-sm-secondary"
              >
                Unmute
              </button>
              <button
                onClick={() => logoutUser(p.userId)}
                className="btn-sm-danger"
              >
                Logout
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* <div className="mt-10">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">
          Chat Messages
        </h3>
        <div className="bg-white rounded-lg shadow-md p-4 max-h-64 overflow-y-auto">
          {chatMessages.length === 0 ? (
            <p className="text-gray-500">No messages yet</p>
          ) : (
            chatMessages.map((msg, idx) => (
              <div key={idx} className="mb-2">
                <span className="font-semibold text-blue-700">
                  {msg.senderName || "Unknown"}:
                </span>{" "}
                <span>{msg.message}</span>
              </div>
            ))
          )}
        </div>
      </div> */}
    </div>
  );
};

export default Zoom;
